import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/AgencySearch.css';
import iconTitle from '../../assets/img/icon-square.svg';
import AdminHeader from '../../components/headers/AdminHeader';
import { searchAgency } from '../../services/api/AgencyService';

// 代理店検索ページコンポーネント
// ※pages/agencyにも同様のコンポーネントがあるため、修正時は同時に確認すること
const AgencySearch = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useState({
    trading_code: '',
    name: ''
  });
  const [searchResults, setSearchResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(3);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [isLoading, setIsLoading] = useState(false);
  
  // 検索パラメータの変更ハンドラ
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({ ...prev, [name]: value }));
  };

  // 検索実行
  const handleSearch = async () => {
    setIsLoading(true);

    try {
      // 検索条件を準備（空の値は送信しない）
      const requestBody = {};
      if (searchParams.trading_code) requestBody.trading_code = searchParams.trading_code;
      if (searchParams.name) {
        const isKanaOrHiragana = /^[\u30A0-\u30FF\u3040-\u309F]+$/.test(searchParams.name);
        if (isKanaOrHiragana) {
          requestBody.agency_name_kana = searchParams.name;
        } else {
          requestBody.agency_name = searchParams.name;
        }
      }
      const response = await searchAgency(requestBody);
      setSearchResults(response.results);
      setCurrentPage(1);
    } catch (error) {
      // エラーダイアログ表示はBaseApiServiceで行う
      // エラーコンソール出力は各ApiServiceで行う
    } finally {
      setIsLoading(false);
    }
  };

  // フォームクリア
  const handleClear = () => {
    setSearchParams({ trading_code: '', name: '' });
    setSearchResults([]);
  };

  // 詳細ページへの遷移処理
  const navigateToDetail = (agency, event) => {
    if (event) {
      // ボタンクリックで発火した場合はイベントの伝播を止める
      event.stopPropagation();
    }
    
    // 詳細画面に遷移
    navigate(`/admin/agency/detail/${agency.id}`);
  };

  // 住所を結合
  const formatAddress = (prefecture, city, building) => {
    return [prefecture, city, building].filter(Boolean).join(' ');
  };

  return (
    <div className="agency-search-page">
      <AdminHeader onMenuToggle={(isOpen) => {
        // メニューの状態が変更された時の処理をここに追加できます
      }} />
      <div className="page-container">
        <div className="content-wrapper">
        <div className="page-header">
          <div className="title-section">
            <div className="icon-square">
              <img src={iconTitle} alt="タイトルアイコン" className="" />
            </div>
            <h1>代理店検索</h1>
          </div>
          <button className="register-button c-max-s-small" onClick={() => navigate('/admin/agency/registration/')}>
            新規代理店登録
          </button>
        </div>

        <div className="search-panel">
          <div className="search-fields">
            <div className="field-row">
              <div className="field-label">取引先コード</div>
              <div className="field-input">
                <input
                  type="text"
                  name="trading_code"
                  value={searchParams.trading_code}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="field-row">
              <div className="field-label">代理店名・カナ</div>
              <div className="field-input">
                <input
                  type="text"
                  name="name"
                  value={searchParams.name}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="search-buttons">
            <button 
              className="button button-medium search-button-login"
              onClick={handleSearch}
              disabled={isLoading}
            >
              {isLoading ? '検索中...' : '代理店検索'}
            </button>
          </div>
        </div>

        {searchResults.length > 0 && (
          <div className="results-section">
            <div className="results-header">
              <div className="title-section">
                <div className="icon-square">
                  <img src={iconTitle} alt="タイトルアイコン" className="" />
                </div>
                <h2>検索結果</h2>
              </div>
            </div>

            <div className="results-table-container">
              <table className="results-table">
                <thead>
                  <tr>
                    <th>取引先コード</th>
                    <th>代理店名</th>
                    <th>住所</th>
                    <th>契約日</th>
                    <th>募集人数</th>
                    <th>新規作成日</th>
                    <th>更新日</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {searchResults.map((agency, index) => (
                    <tr key={index}>
                      <td>{agency.trading_code}</td>
                      <td>{agency.name}</td>
                      <td>{formatAddress(agency.prefecture, agency.city, agency.building)}</td>
                      <td>{agency.contract_date ? new Date(agency.contract_date).toLocaleDateString('ja-JP') : ''}</td>
                      <td>{agency.solicitor_count}</td>
                      <td>{agency.created_at ? new Date(agency.created_at).toLocaleDateString('ja-JP') : ''}</td>
                      <td>{agency.updated_at ? new Date(agency.updated_at).toLocaleDateString('ja-JP') : ''}</td>
                      <td>
                        <button 
                          className="btn-confirm-mini" 
                          onClick={(e) => navigateToDetail(agency, e)}
                        >
                          詳細
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="results-actions search-buttons">
              <button className="clear-button" onClick={handleClear}>クリア</button>
              <button className="search-button" onClick={() => navigate('/admin/agency/registration')}>新規代理店登録</button>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default AgencySearch;